var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNext(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "UI icon/arrow_forward/light"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M13.7929 17.7929C13.4024 18.1834 13.4024 18.8166 13.7929 19.2071C14.1834 19.5976 14.8166 19.5976 15.2071 19.2071L21 13.4142C21.781 12.6332 21.781 11.3668 21 10.5858L15.2071 4.79289C14.8166 4.40237 14.1834 4.40237 13.7929 4.79289C13.4024 5.18342 13.4024 5.81658 13.7929 6.20711L18.5858 11H4.5C3.94772 11 3.5 11.4477 3.5 12C3.5 12.5523 3.94772 13 4.5 13H18.5858L13.7929 17.7929Z",
    fill: "#111315"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNext);
export default __webpack_public_path__ + "static/media/next.7f7ac2a7426393f5fe2627722dbe08b0.svg";
export { ForwardRef as ReactComponent };